/*

Pixel Field Editor - developed by Satori, s.r.o. (c) 2014-2016 - zden@satori.sk
---------------------------------
Legal notice: Source code is for internal purposes only of developing
and integrating Pixel Field Editor to the larger asset of Forms+Surfaces
online services. Any modifications must be discussed with Satori, s.r.o. and no derivates to other projects are allowed without prior written permission from Satori, s.r.o.
---------------------------------
Satori, s.r.o. | Jegeho 21 | 821 08 Bratislava | +421-903-258-862 | www.satori.sk

*/


function vectorize_stripes(worker, dim_wid, dim_hei, layer, detail, detail_data, offset, width, variation, coverage, rotation, rnd)
{
	vectors = [ ];
	var shapes = 0;
	var dim = max(dim_wid, dim_hei);
	var dim_shift = new vec2(- (dim - dim_wid)/2, - (dim - dim_hei)/2);

	var x;
	var wid_rnd;
	var dist;
	var xp, yp, x_rnd, y_rnd;
	var a, c;
	var ang;
	var dimh = dim / 2;
	var view;
	var single = 0, half = 0, layer_out = layer;

	if (layer == 2)
	{
		layer = 0; half = 0; single = 1;
		layer_out = 0;
	}
	else
	if (layer == 3)
	{
		layer = 0; half = 1; single = 1;
		layer_out = 1;
	}

	if (!detail)
		view = { x: 0, y: 0, w: dim_wid, h: dim_hei };
	else
 		view = { x:detail_data.pos[0] - detail_data.bleed, y: detail_data.pos[1] - detail_data.bleed, w: detail_data.dim[0] + detail_data.bleed*2, h: detail_data.dim[1] + detail_data.bleed*2 };

	ang = (2*PI*rotation)/360;

	seed(Math.floor(variation+coverage+Math.floor(width*779)));

	dist = Math.sqrt(dim*dim + dim*dim);

	var vst = new vec2(dimh-dist/2+offset, dimh);
	var voff = new vec2(0, dist/2);
	vst.rot(ang, dimh, dimh);
	voff.rot(ang, 0, 0);

//

	vst.add(dim_shift);

	var a_start = 0;

	if (single)
	{
		if (!half) dist /= 2;
		else
		{
			for (a = 0; a < dist/2; a += wid_rnd, vst.add(vdir))
			{
				wid_rnd = (width * (random() * variation)) / 100;
				var vdir = new vec2(wid_rnd, 0);
				vdir.rot(ang, 0, 0);
				random();

				random();
				random();
				random();
				random();
				random();
			}
			a_start = a;
		}
	}

	var use_last, last_p = 0;
	for (a = a_start; a < dist; a += wid_rnd, vst.add(vdir))
	{
		wid_rnd = (width * (random() * variation)) / 100;
		var vdir = new vec2(wid_rnd, 0);
		vdir.rot(ang, 0, 0);
//
		if (random()*100 > coverage) continue;
//
		var v1 = vst.copy(), v2 = vst.copy(), v3 = vst.copy(), v4 = vst.copy();
		v1.add(voff);
		v2.add(voff);
		v2.add(vdir);
		v3.sub(voff);
		v3.add(vdir);
		v4.sub(voff);

		if (intersect_line_rect({x1:v1.x,y1:v1.y,x2:v2.x,y2:v2.y}, view) |
			intersect_line_rect({x1:v2.x,y1:v2.y,x2:v3.x,y2:v3.y}, view) |
			intersect_line_rect({x1:v3.x,y1:v3.y,x2:v4.x,y2:v4.y}, view) |
			intersect_line_rect({x1:v4.x,y1:v4.y,x2:v1.x,y2:v1.y}, view))
		{
			var cvec = v1.copy();
			cvec.iter(v3.x, v3.y, random());
			xp = Math.floor((cvec.x* x_res)/ dim_wid);
			yp = Math.floor((cvec.y* y_res)/ dim_hei);

			x_rnd = Math.floor((random() * x_res * rnd)/ 256);
			if (random() > 0.5) x_rnd *= -1;
			xp += x_rnd;

			y_rnd = (random() * y_res * rnd) / 256;
			if (random() > 0.5) y_rnd *= -1;
			yp += y_rnd;

			xp = Math.floor(xp);
			yp = Math.floor(yp);

			if (yp < 0) yp *= -1;
			if (yp >= y_res) yp = 2*y_res - 1 - (yp % (2*y_res));

			if (xp < 0) xp *= -1;
			if (xp >= x_res) xp = 2*x_res - 1 - (xp % (2*x_res));

			use_last = (xp < 0 || xp >= x_res || yp < 0 || yp >= y_res) ? 1 : 0;

			p = (yp*x_res + xp) << 2;

			if (use_last) p = last_p;

			if (layer)
				c = '#'+tab_colhex[image_data[p]]+tab_colhex[image_data[p+1]]+tab_colhex[image_data[p+2]];
			else
				c = color_adjust(image_data[p], image_data[p+1], image_data[p+2]);
			last_p = p;

			vectors.push( {g:"p", x1:v1.x, y1:v1.y, x2:v2.x, y2:v2.y, x3:v3.x, y3:v3.y, x4:v4.x, y4:v4.y, c: c, a: 1 });
		}
		else
		{
			random();
			random();
			random();
			random();
			random();
		}

		if (worker && shapes > 20000)
		{
			postMessage({done:0,layer:layer,pos:detail,out:vectors});
			vectors.length = 0;
			shapes = 0;
		}
		shapes++;
	}

	if (worker)
		postMessage({done:1,layer:layer,pos:detail,out:vectors});

	if (!worker)	
		return vectors;
}
